import React from "react";

const Footer = () => {
  return (
    <div className="footer">
      <div className="copyright">
        <p>
          Copyright © All Rights Reserved
          2023
        </p>
      </div>
    </div>
  );
};

export default Footer;
